import { Component } from '@angular/core'

@Component({
  selector: 'app-header-countries-loader',
  template: ` <div class="spinner column is-12">
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
      <div class="column is-12-mobile is-12-touch is-3-desktop py-0">
        <div
          class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2"
        >
          <div class="spinner--flag mr-2"></div>
          <div class="spinner--label"></div>
        </div>
      </div>
    </div>
  </div>`
})
export class HeaderCountriesLoaderComponent {}
